var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selected__option"},[_c('p',{staticClass:"selected__text"},[_vm._v(_vm._s(_vm.option))]),_vm._v(" "),_c('button',{staticClass:"selected__close fa fa-times",on:{"click":function($event){return _vm.deselectOption()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }